// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Insert = function Insert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.125 3.955c0-.53.418-.955.938-.955.519 0 .937.426.937.955v3.819c0 2.108-1.68 3.819-3.75 3.819H3.2l3.71 3.78a.963.963 0 0 1 0 1.348.925.925 0 0 1-1.324 0L.273 11.315A.96.96 0 0 1 0 10.638c0-.254.098-.497.273-.676l5.313-5.41a.92.92 0 0 1 1.324 0 .967.967 0 0 1 0 1.348L3.2 9.68h13.05c1.035 0 1.875-.856 1.875-1.91V3.95z"
  }));
};
